import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([]);

const ProgressBar = helpers.defineMultiStyleConfig({
  baseStyle: {
    ProgressBarContainer: {
      display: 'flex',
      justifyContent: 'space-evenly',
      left: 0,
      '&[data-is-preview="false"]': {
        width: '100vw',
        marginLeft: '-2rem',
      },
    },
    ProgressBarItem: {
      height: '36px',
      width: '100%',
      backgroundColor: 'progressBar.progressBarItem.background.incomplete',
      '&[data-selected="true"]': {
        backgroundColor: 'progressBar.progressBarItem.background.complete',
      },
    },
    ProductCountLabelContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      color: 'progressBar.productCountLabel.color.incomplete',
      '&[data-is-empty="true"]': {
        flexDirection: 'row',
        color: 'progressBar.productCountLabel.color.complete',
      },
      alignItems: 'center',
      height: '36px',
      position: 'relative',
      padding: '0px 8px',
    },
    ProgressBarCountLabel: {
      fontSize: '14px',
      lineHeight: '16px',
      margin: 0,
      '&[data-is-preview="false"]': {
        position: 'fixed',
      },
    },
    RemoveButton: {
      display: 'none',
      '&::after': {
        content: '"x"',
      },
    },
  },
  sizes: {},
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
});

export default ProgressBar;
